<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <b-col md="2"> </b-col>
      <b-col
        lg="8"
        class="d-flex align-items-center justify-content-center px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="7"
          class="px-xl-2 mx-auto"
        >
          <validation-observer
            ref="loginForm"
            #default="{invalid}"
          >
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="login"
            >
              <b-form-group
                class="mb-3"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  vid="email"
                  rules="required|email"
                >
                  <feather-icon icon="MailIcon" class="field-icon" size="25" />
                  <b-form-input
                    id="login-email"
                    v-model="loginForm.email"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                    placeholder="Email"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required"
                >
                  
                  <feather-icon icon="UnlockIcon" class="field-icon" size="25" />
                  <b-form-input
                    id="login-password"
                    v-model="loginForm.password"
                    :state="errors.length > 0 ? false:null"
                    class="form-control-merge"
                    :type="passwordFieldType"
                    name="login-password"
                    placeholder="Password"
                  />
                  <feather-icon
                      class="cursor-pointer show-pass-icon"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-link :to="{name:'auth-forgot-password'}">
                <small class="forgot-pass">Forgot Password?</small>
              </b-link>
              <div class="pt-5">
                <b-row>
                  <b-col md="6">
                    <b-button
                      type="submit"
                      variant="secondary"
                      inline
                      :disabled="invalid"
                      style="background-color: #727272 !important; border: unset !important"
                      class="w-100 d-flex align-items-center justify-content-center p-0 py-50"
                    >
                      <feather-icon icon="CheckIcon" size="25" />
                      <span class="mx-1"> Login </span>
                    </b-button>
                  </b-col>
                  <b-col md="6">
                    <b-button 
                      variant="secondary" 
                      :to="{name:'auth-register'}"
                      class="w-100 d-flex align-items-center justify-content-center p-0 py-50"
                      style="background-color: #727272 !important; border: unset !important"
                    >
                      <feather-icon icon="EditIcon" size="25" />
                      <span class="mx-1">Signup</span>
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
      <b-col md="2"> </b-col>
    </b-row>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, BAlert, VBTooltip,
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      userEmail: '',
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      loginForm: {
        email: "admin@vero.com",
        password: "12345678",
      },
      // validation rules
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    login() {
      this.$refs.loginForm.validate().then((success) => {
        if (success) {
          const payload = { query: this.loginForm };
          this.$store.dispatch("users/login", payload).then((res) => {
            localStorage.setItem("userData", JSON.stringify(res.user));
            localStorage.setItem(
              useJwt.jwtConfig.storageTokenKeyName,
              res.access_token
            );  
            this.$router.replace('/');
          }).catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: `<h4>${error.response.data.message}</h4>`,
                  showConfirmButton: true,
                  confirmButtonColor: '#E84185',
                  allowOutsideClick: true
                });
              }
          });
        }
      });
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

[dir] .dark-layout input.form-control, [dir] .dark-layout .custom-file-label, [dir] .dark-layout textarea.form-control {
    height: 45px;
    box-shadow: black beige indigo;
    border-radius: 8px;
    box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.4);
    background: linear-gradient(90deg, rgba(158, 63, 217, 0.2) 0%, rgba(37, 78, 158, 0.2) 49%, rgba(70, 124, 227, 0.2) 100%);
    border: 2px solid #ffffff3c;
    border-left: none;
    border-right: none;
    border-top: none;
}
[dir] .dark-layout input.form-control:not(:focus), [dir] .dark-layout .custom-file-label:not(:focus), [dir] .dark-layout textarea.form-control:not(:focus) {
    border-color: #ffffff3c;
}

.form-group span{
  position: relative;
}

.field-icon{
  position: absolute;
  top: 10px;
  left: 30px;
  color: #ffffffcc !important;
  font-weight: 500;
}
.form-control{
  padding-left: 65px;
  color: #ffffffe6 !important;
}
.form-control::placeholder{
  color: #ffffffe6 !important;
  font-size: 16px;
  margin-top: 55px !important;
  font-weight: 300 !important;
}
.show-pass-icon{
  position: absolute;
  right: 30px;
  top: 15px;
}
.forgot-pass{
  color: #ffffff70;
  text-decoration: underline;
}
</style>
